module.exports = "/_next/static/images/3a63484cb9d8f3714c09784f1d0fa0e0-ticket-02-02.png";